import { render, staticRenderFns } from "./WorkRegionTable.vue?vue&type=template&id=b6fd483c&"
import script from "./WorkRegionTable.vue?vue&type=script&lang=js&"
export * from "./WorkRegionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports